import request from "_private/utils/request";

/**
 * 功能:企业统计汇总
 * @Author  LiuYunYang【liuyunyang@e6yun.com】
 * @Date    2019/10/22 11:51
 */
/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchFindByPage(data) {
    return request({
        url: "/base/comparyGroup/findByPage",
        method: "post",
        data
    });
}